import type { TrackPoint } from "@/types";

export interface LocationResult { latitude: number; longitude: number; accuracyM: number; speedKmh?: number }

export function currentLocation(): Promise<LocationResult> {
  return new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition((position) => resolve({
    latitude: position.coords.latitude, longitude: position.coords.longitude,
    accuracyM: position.coords.accuracy, speedKmh: position.coords.speed == null ? undefined : position.coords.speed * 3.6,
  }), () => reject(new Error("无法获取定位，请在系统设置中选择始终允许")), {
    enableHighAccuracy: true, timeout: 15000, maximumAge: 5000,
  }));
}

export function watchLocation(onBatch: (points: TrackPoint[]) => void) {
  let queue: TrackPoint[] = [];
  const flush = () => { if (queue.length) { onBatch(queue); queue = []; } };
  const timer = window.setInterval(flush, 30_000);
  const watchId = navigator.geolocation.watchPosition((position) => {
    queue.push({
      latitude: position.coords.latitude, longitude: position.coords.longitude,
      accuracyM: position.coords.accuracy,
      speedKmh: position.coords.speed == null ? undefined : position.coords.speed * 3.6,
      capturedAt: new Date(position.timestamp).toISOString(),
    });
    if (queue.length >= 10) flush();
  }, () => undefined, { enableHighAccuracy: true, maximumAge: 10_000, timeout: 20_000 });
  return () => { navigator.geolocation.clearWatch(watchId); window.clearInterval(timer); flush(); };
}
